import { StatusTone } from './statusColors';

/**
 * O TOM DE CADA STATUS DA FATURA, o domínio inteiro (10/10/2026).
 *
 * Parcial e Rascunho dividiam o âmbar: "pagou uma parte" e "ainda não aprovei" pareciam a mesma pendência. Parcial é
 * pagamento EM ANDAMENTO (`progress`, azul); o âmbar fica com o Rascunho, que é o que pede ação de quem opera.
 *
 * Os cinco status do servidor (InvoiceStatus) e o derivado "Vencida" (Aberta/Parcial com vencimento passado). Status
 * que não estiver aqui cai no neutro, e o teste trava que os seis estão mapeados e que nenhum dos que pedem leitura
 * diferente divide tom.
 */
export const STATUS_DA_FATURA = ['Rascunho', 'Aberta', 'Parcial', 'Paga', 'Cancelada', 'Vencida'] as const;
export type StatusDaFatura = (typeof STATUS_DA_FATURA)[number];

export const TOM_DO_STATUS_DA_FATURA: Record<StatusDaFatura, StatusTone> = {
  Rascunho: 'warning',
  Aberta: 'open',
  Parcial: 'progress',
  Paga: 'success',
  Cancelada: 'neutral',
  Vencida: 'danger',
};

export function tomDoStatusDaFatura(status: string | null | undefined): StatusTone {
  return (TOM_DO_STATUS_DA_FATURA as Record<string, StatusTone>)[status || ''] ?? 'neutral';
}
